import { Flex } from '@chakra-ui/react';
import { FC } from 'react';
import { Recommendation } from 'model/modules/portfolio/rebalance';
import RebalanceGridItem from './RebalanceGridItem';

interface Props {
  recs: Recommendation[];
  createdAt: Date;
}

const RebalanceGrid: FC<Props> = ({ recs, createdAt }) => {
  return (
    <Flex flexWrap="wrap" justifyContent="space-between">
      {recs.map((rec) => (
        <RebalanceGridItem createdAt={createdAt} rec={rec} key={rec.id}/>
      ))}
    </Flex>
  );
};

export default RebalanceGrid;
